import {DataFetcher} from '@aboutyou/data-fetcher';
import React from 'react';
import {
  StreamHeader,
  StreamHeaderProps,
} from '../../../features/StreamHeader/StreamHeader';
import {StreamHeaderErrorView} from '../../../features/StreamHeader/StreamHeaderErrorView';
import {StreamHeaderLoading} from '../../../features/StreamHeader/StreamHeaderLoading';
import {StreamGenderSwitch} from '../StreamGenderSwitch/StreamGenderSwitch';
import {useCouponLandingPageFilters} from './useCouponLandingPageFilters';

export const CouponLandingPageStreamHeader: React.FC<
  StreamHeaderProps
> = props => {
  return (
    <DataFetcher
      request={useCouponLandingPageFilters()}
      Error={StreamHeaderErrorView}
      Loading={StreamHeaderLoading}
      View={viewProps => (
        <StreamHeader
          {...viewProps}
          hideProductCount={false}
          StreamGenderSwitch={
            <StreamGenderSwitch adjustGenderQueryParam={true} />
          }
        />
      )}
      viewProps={props}
    />
  );
};
